<div class="grid-container">
  <div class="overlay-sidebar" [class.active]="isSidebarOpen || isUserMenuOpen" [class.gray]="isSidebarOpen" (click)="CloseAllMenus()"></div>
  <!---========== Sidebar ==========--->
  <aside class="sidebar" id="sidebar" [class.SeeToogle]="isSidebarOpen">
    <div class="top">
      <div class="logo">
        <img src="./assets/Global/Icon_SINCO.png" alt="" style="width: 40px; height: 40px;"/>
      </div>
      <a routerLink="/Dashboard/General/HomeSystemCDMS" class="title"><span>Librerías</span> </a>
      <div class="close-sidebar" (click)="ActiveSideBar()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <ul>
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/HomeSystemCDMS">
          <span class="icon"><i class="fas fa-house-user"></i></span>
          <span class="title">Inicio</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a [routerLink]="['/Dashboard/Lib', LibraryGeneral.CCP]">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">HOE</span>
        </a>
      </li>

      <!-- <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/Dashboard/ISO">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">ISO</span>
        </a>
      </li> -->

      <li class="list" [class.active]="IsProcessesSectionActive()">
        <a routerLink="/Dashboard/FIN">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">Processes</span>
        </a>
      </li>

      <!-- Librerías Dinámicas Adicionales -->
      <li class="list" *ngFor="let lib of activeLibraries" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a [routerLink]="['/Dashboard/Lib', lib.Slug]">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">{{lib.Nombre}}</span>
        </a>
      </li>
      <!-- <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">HR Processes</span>
        </a>
      </li> -->
      <!-- <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/Dashboard/SEC">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title title2">Safety & Health Processes</span>
        </a>
      </li> -->
      <!-- <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/Dashboard/IT">
          <span class="icon"><i class="fas fa-book"></i></span>
          <span class="title">IT/IS Processes</span>
        </a>
      </li> -->
      <li class="list" [class.active]="IsTasksSectionActive()">
        <a routerLink="/Dashboard/General/SeeAllTaskCDMS">
          <span class="icon"><i class="fas fa-list"></i></span>
          <span class="title">Tareas</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/AdvancedSearch">
          <span class="icon"><i class="fas fa-magnifying-glass"></i></span>
          <span class="title">Búsqueda Avanzada</span>
        </a>
      </li>
      <!--<li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/ManualsGeneral">
          <span class="icon"><i class="fa-solid fa-book-bookmark"></i></span>
          <span class="title">Manuales</span>
        </a>
      </li> 
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/TemplatesGCDMS">
          <span class="icon"><i class="fa-solid fa-book-bookmark"></i></span>
          <span class="title">Plantillas</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/QualityGeneral">
          <span class="icon"><i class="fas fa-file-signature"></i></span>
          <span class="title">Política de Calidad</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/General/RiskOppGeneral">
          <span class="icon"><i class="far fa-clipboard"></i></span>
          <span class="title title2">Riesgos y oportunidades</span>
        </a>
      </li> -->
      <li class="list" [routerLinkActive]="'active'" *ngIf="CanAccessFormModule()">
        <a routerLink="/Dashboard/General/FormTemplates">
          <span class="icon"><i class="fa-solid fa-file-lines"></i></span>
          <span class="title">Formularios</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" *ngIf="CanAccessFormDashboard()">
        <a routerLink="/Dashboard/General/FormReports">
          <span class="icon"><i class="fa-solid fa-chart-line"></i></span>
          <span class="title">Dashboard</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" *ngIf="CanSeeReportsMenu()">
        <a routerLink="/Dashboard/General/SeeReportsCDMS">
          <span class="icon"><i class="fa-solid fa-clipboard"></i></span>
          <span class="title">Reportes</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" *ngIf="CanSeeRecycleMenu()">
        <a routerLink="/Dashboard/Admin/MenuRecycleBin">
          <span class="icon"><i class="fa-solid fa-recycle"></i></span>
          <span class="title">Papelera de reciclaje</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" *ngIf="CanSeeAdministratorMenu()">
        <a routerLink="/Dashboard/Admin/DAdministrator">
          <span class="icon"><i class="fa-solid fa-user-shield"></i></span>
          <span class="title">Administrador</span>
        </a>
      </li>
    </ul>
    <div class="Bottom">
      <li class="list" [routerLinkActive]="'active'">
        <a (click)="CloseSession()">
          <span class="icon"><i class="fa-solid fa-arrow-right-from-bracket fa-rotate-180"></i></span>
          <span class="title">Cerrar sesión</span>
        </a>
      </li>
    </div>
  </aside>

  <!---========== Main ==========--->
  <main class="main-container">
    <nav class="navbar" [class.user-menu-active]="isUserMenuOpen">
      <div class="left-nav">
        <div (click)="ActiveSideBar()" class="bars">
          <i class="fa-solid fa-bars"></i>
        </div>
        <!-- <div class="search inputText">
          <i class="fa-solid fa-magnifying-glass"></i><input type="text" placeholder="Buscar">
        </div> -->
      </div>
      <div class="right-nav">
        <!-- <div class="notifications button-square Drop_Lenguage">
          <p-select [options]="translate.getLangs()" [(ngModel)]="Selected"
            (onChange)="switchLang(Selected)"></p-select>
          <span class="number-circle"><i class="fa-solid fa-earth-americas"></i></span>
        </div> -->

        <!-- <div class="notifications button-square" (click)="ToggleNotifications(); $event.stopPropagation()">
          <i class="far fa-bell" [class.animate-bell]="unreadNotificationsCount > 0"></i>
          <span class="number-circle" *ngIf="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
          
          <div class="notification-panel" [class.show-panel]="isNotificationsOpen" (click)="$event.stopPropagation()">
            <div class="panel-header">
              <h3>Notificaciones</h3>
              <span class="mark-read" (click)="MarkAllNotificationsAsRead()" *ngIf="unreadNotificationsCount > 0">
                Marcar leídas
              </span>
            </div>
            <div class="panel-body">
              <div class="empty-state" *ngIf="notifications.length === 0">
                <i class="fa-regular fa-bell-slash"></i>
                <p>No tienes notificaciones</p>
              </div>
              <div class="noti-item" *ngFor="let noti of notifications" [class.unread]="!noti.Read_Noti">
                <div class="noti-icon" [ngClass]="{'rejected': noti.Mail_Type === 3, 'approved': noti.Mail_Type === 4, 'assigned': noti.Mail_Type === 1}">
                  <i class="fa-solid fa-circle-exclamation" *ngIf="noti.Mail_Type === 3"></i>
                  <i class="fa-solid fa-check" *ngIf="noti.Mail_Type === 4"></i>
                  <i class="fa-solid fa-file-signature" *ngIf="noti.Mail_Type === 1"></i>
                </div>
                <div class="noti-content">
                  <p class="noti-title">{{ noti.Name_Document }}</p>
                  <p class="noti-desc" *ngIf="noti.Mail_Type === 3">Documento rechazado por {{ noti.Name_Sender }}</p>
                  <p class="noti-desc" *ngIf="noti.Mail_Type === 4">Documento aprobado por {{ noti.Name_Sender }}</p>
                  <p class="noti-desc" *ngIf="noti.Mail_Type === 1">Nueva revisión asignada por {{ noti.Name_Sender }}</p>
                  <span class="noti-time">{{ noti.Date_Created | date:'short' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div (click)="ToggleMenuUser(); $event.stopPropagation()" class="user">
          <div class="name-user">
            {{ NameUser() }}
          </div>
          <div class="img">
            <img src="./assets/Global/Icon_user.png" alt="" />
          </div>
          <span class="arrow"><i class="fa-solid fa-angle-down"></i></span>
          <div class="menu-side" [class.ShowMenuUser]="isUserMenuOpen" id="ShowMenuUser" (click)="$event.stopPropagation()">
            <ul>
              <!-- <li class="item-user"><i class="fa-regular fa-user"></i><span class="item-user-text">Ver Perfil</span>
              </li>
              <li class="item-user"><i class="fa-regular fa-bell"></i><span class="item-user-text">Notificaciones</span>
              </li> -->
              <li routerLink="/Dashboard/General/SeeAllTaskCDMS" (click)="CloseAllMenus()" class="item-user">
                <i class="fa-solid fa-list-check"></i><span class="item-user-text">Tareas</span>
              </li>
              <li (click)="CloseSession()" class="item-user">
                <i class="fa-solid fa-right-from-bracket"></i><span class="item-user-text">Cerrar sesión</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <section class="container-global">
      <router-outlet></router-outlet>
    </section>
  </main>
  <app-form-modal-cdms></app-form-modal-cdms>
</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global active" id="Loader" *ngIf="isLoadingLogout">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
